import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { CatalogRepoPicker } from './CatalogRepoPicker';

export const CatalogRepoPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'CatalogRepoPicker',
    component: CatalogRepoPicker,
  }),
);
